import { render, staticRenderFns } from "./zlCertification.vue?vue&type=template&id=8fe3963a&scoped=true&"
import script from "./zlCertification.vue?vue&type=script&lang=js&"
export * from "./zlCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe3963a",
  null
  
)

export default component.exports